import { ShippingCondition } from '@cemex-core/cmx-api/models/shipping-conditions/shipping-condition';
import {
  OneClickShippingMethodActions,
  OneClickShippingMethodActionTypes,
} from '../actions/one-click-shipping-method.actions';

export interface OneClickShippingMethodState {
  loading: boolean;
  shippingMethodsAvailable: ShippingCondition[];
  selected: ShippingCondition;
}

export const initialState: OneClickShippingMethodState = {
  loading: false,
  shippingMethodsAvailable: [],
  selected: null,
};

export function reducer(state = initialState, action: OneClickShippingMethodActions): OneClickShippingMethodState {
  switch (action.type) {
    case OneClickShippingMethodActionTypes.LOAD: {
      return {
        ...state,
        loading: true,
      } as OneClickShippingMethodState;
    }
    case OneClickShippingMethodActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        shippingMethodsAvailable: action.payload,
      } as OneClickShippingMethodState;
    }
    case OneClickShippingMethodActionTypes.SELECT: {
      return {
        ...state,
        selected: action.payload,
      } as OneClickShippingMethodState;
    }
    case OneClickShippingMethodActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
